module.exports = __webpack_public_path__ + "img/face-grin-beam-sweat.a5e0991e.svg";